import { GridWrapper } from "../../App/Pages/styles/Grid.styled";
import React from "react";
import styled from "styled-components";
import { useState } from "react";
import query from "../../../server/constants.api";
import { useEffect } from "react";
import renderComponent from "../../../utils/serializers/renderComponent";
import useMultipleFetch from "../../../server/useMultipleFetch";
import { useConfigContext } from "../../../contexts/ConfigContext";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: [col1] 3840px [col2] 2560px;
  height: 100vh;
  width: 100vw;
`;
//1280 - 1440

const ZoneB = styled.div`
  display: grid;
  grid-column: col1;
  /* border-radius: 12px; */
  /* margin: 8px; */
`;

const ZoneE = styled.div`
  grid-column: col2;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${props => (props.rows ? props.rows : '0.6fr 3fr')};
  max-height: 100%;
`;

//3840px 1920px
//   grid-template-rows: 3fr 1.2fr;

const LayoutMap = () => {
    const { currentConfig } = useConfigContext();

    const queryResults = useMultipleFetch([
        { path: query.path.layoutZonaB, id: 'getLayoutZonaB' },
        { path: query.path.layoutZonaE, id: 'getLayoutZonaE' }
    ]);

    const [layoutBData, setLayoutBData] = useState(null);
    const [layoutEData, setLayoutEData] = useState(null);

    useEffect(() => {
        setLayoutBData(queryResults[0]?.data?.data);
    }, [queryResults[0]?.isLoading]);

    useEffect(() => {
        console.log('zona e', queryResults[1]?.data?.data);
        setLayoutEData(queryResults[1]?.data?.data);
    }, [queryResults[1]?.isLoading]);

    return (
        <>
            <GridWrapper>
                <GridContainer>
                    <ZoneB>
                        {/* <MapsWidget /> */}
                        {layoutBData ? layoutBData?.map((element) => {
                            return renderComponent(element)
                        }) : null}
                    </ZoneB>
                    <ZoneE>
                        {layoutEData ? layoutEData.map((element) => {
                            return renderComponent(element)
                        }) : null}
                    </ZoneE>
                </GridContainer>
            </GridWrapper>
        </>
    );
}

export default LayoutMap;